module.exports = __webpack_public_path__ + "media/src/public/img/heart-f05fc9d196cef5be41c57f57c538359c.webp";